import { useLayoutEffect, useRef, useState } from 'react';
import { theme } from 'antd';

/**
 * Height that takes the element to the bottom of the viewport, so its columns
 * scroll on their own and their footers stay pinned. Measured from the element's
 * page offset on mount and on resize.
 *
 * @param {boolean} enabled - off on narrow screens, where the columns stack and the page scrolls
 * @returns {[import('react').RefObject, number | undefined]} the ref to attach, and the height
 */
export const useFillViewportHeight = enabled => {
	const {
		token: { marginLG: bottomGutter },
	} = theme.useToken();
	const ref = useRef(null);
	const [height, setHeight] = useState();

	useLayoutEffect(() => {
		if (!enabled) {
			setHeight(undefined);
			return undefined;
		}

		const measure = () => {
			const top = (ref.current?.getBoundingClientRect().top ?? 0) + window.scrollY;
			setHeight(Math.max(window.innerHeight - top - bottomGutter, 0));
		};

		measure();
		window.addEventListener('resize', measure);
		return () => window.removeEventListener('resize', measure);
	}, [enabled, bottomGutter]);

	return [ref, height];
};
